"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketStatistics$ = exports.MarketStatistics$outboundSchema = exports.MarketStatistics$inboundSchema = void 0;
exports.marketStatisticsToJSON = marketStatisticsToJSON;
exports.marketStatisticsFromJSON = marketStatisticsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const marketstatisticslocalauthority_js_1 = require("./marketstatisticslocalauthority.js");
const marketstatisticsnational_js_1 = require("./marketstatisticsnational.js");
const marketstatisticsoutcode_js_1 = require("./marketstatisticsoutcode.js");
/** @internal */
exports.MarketStatistics$inboundSchema = z.object({
    local_authority: z.nullable(marketstatisticslocalauthority_js_1.MarketStatisticsLocalAuthority$inboundSchema),
    national: z.nullable(marketstatisticsnational_js_1.MarketStatisticsNational$inboundSchema),
    outcode: z.nullable(marketstatisticsoutcode_js_1.MarketStatisticsOutcode$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "local_authority": "localAuthority",
    });
});
/** @internal */
exports.MarketStatistics$outboundSchema = z.object({
    localAuthority: z.nullable(marketstatisticslocalauthority_js_1.MarketStatisticsLocalAuthority$outboundSchema),
    national: z.nullable(marketstatisticsnational_js_1.MarketStatisticsNational$outboundSchema),
    outcode: z.nullable(marketstatisticsoutcode_js_1.MarketStatisticsOutcode$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        localAuthority: "local_authority",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MarketStatistics$;
(function (MarketStatistics$) {
    /** @deprecated use `MarketStatistics$inboundSchema` instead. */
    MarketStatistics$.inboundSchema = exports.MarketStatistics$inboundSchema;
    /** @deprecated use `MarketStatistics$outboundSchema` instead. */
    MarketStatistics$.outboundSchema = exports.MarketStatistics$outboundSchema;
})(MarketStatistics$ || (exports.MarketStatistics$ = MarketStatistics$ = {}));
function marketStatisticsToJSON(marketStatistics) {
    return JSON.stringify(exports.MarketStatistics$outboundSchema.parse(marketStatistics));
}
function marketStatisticsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MarketStatistics$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MarketStatistics' from JSON`);
}
//# sourceMappingURL=marketstatistics.js.map